<template>
  <div>
    <!-- CONTAINER TO TELEPORT FILTER TO -->
    <div
      id="sidebar-filter"
      class="empty:hidden"
    />
    <!-- SIDEBAR COMPONENTS -->
    <LoaderComponents
      v-editor-target="'sidebar_components'"
      class="space-y-7"
      :components="data"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: Object, required: true,
  },
})

provide('isSidebar', true)
</script>
